import { SET_STATS, RESET_STATS } from "../types"

export const setStats = (stats) => {
    return {
        type: SET_STATS,
        payload: stats,
    };
};

export const resetStats = () => {
    return {
        type: RESET_STATS,
    };
};
